import { render, staticRenderFns } from "./confirmPay.vue?vue&type=template&id=0b324388&scoped=true&"
import script from "./confirmPay.vue?vue&type=script&lang=js&"
export * from "./confirmPay.vue?vue&type=script&lang=js&"
import style0 from "./confirmPay.vue?vue&type=style&index=0&id=0b324388&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b324388",
  null
  
)

export default component.exports